import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getNotificationEvents } from 'services/WebHooksService'

export const useNotificationEventsQuery = (enabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.events(),
    queryFn: () => getNotificationEvents(),
    enabled,
  })
}
